//if width > 768px
if (window.innerWidth > 768) {
  //select header #main-nav li.menu-item-has-children a and prevent default
  var menuItems = document.querySelectorAll(
    "#main-nav li.menu-item-has-children > a"
  );
  if (menuItems) {
    menuItems.forEach((element) => {
      element.addEventListener("click", function(event) {
        event.preventDefault();
      });
    });
  }
}
